import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentProjectSizeInMbs } from "./state/projectsSliceLegacy";
import { loadGraph, resetGraphInfo } from "./state/graphLegacy";
import SVGGraphContainer from "./components/SVGGraphContainer";
import { getIsLoading, getShouldRerenderGraph, setIsLoading } from "./state/graphuSlice";
import "./index.scss";
import { AppDispatch } from "../../common/state/store";
import { getCurrentProject } from "../projects/state/projectsSlice";
import { prettifyErrorMessage } from "src/common/util/prettifyErrorMessage";
import { setAlert } from "../alert/state/alertsSlice";
import { getCurrentUploadsStateList } from "../gallery/state/gallerySlice";
import { UPLOAD_BAR_HEIGHT } from "src/common/template/Layout";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IEditProjectScenesProps {}

const EditProjectScenes: React.FunctionComponent<IEditProjectScenesProps> = () => {
  const dispatch: AppDispatch = useDispatch();
  const currentProject = useSelector(getCurrentProject);

  const shouldRerender = useSelector(getShouldRerenderGraph);
  const isLoading = useSelector(getIsLoading);
  const currentUploadsStateList = useSelector(getCurrentUploadsStateList);

  // const [error,setError] = React.useState(null as any);
  const error: any = null;

  React.useCallback(() => {
    if (error) {
      throw JSON.parse(error);
    }
  }, [error]);

  const loadGraphFct = () => {
    // before loading we reset the graph info
    // ➡︎ this is to avoid displaying the "wrong" graph while loading or on failure
    dispatch(resetGraphInfo());

    // fetch the project info from the server
    if (currentProject) {
      dispatch(setIsLoading(true));
      dispatch(loadGraph(currentProject.id)).then((res: any) => {
        if (res?.payload?.data?.errorMessages?.length > 0) {
          const prettyErrorMessage = prettifyErrorMessage(
            res.payload.data.errorMessages.join(", "),
          );

          dispatch(
            setAlert({
              msg: prettyErrorMessage.msg,
              subMsg: prettyErrorMessage.subMsg,
              type: "warning",
              isOpen: true,
              customTimeoutInMs: 10000,
            }),
          );
        }
        dispatch(setIsLoading(false));
        if (res?.payload?.data?.sizeInMbs) {
          const sizeInMbs = res?.payload?.data?.sizeInMbs;
          dispatch(setCurrentProjectSizeInMbs(sizeInMbs));
        }

        return res;
      });
      // .catch((e: any) => console.error("EREROR CATCH", e))
    }
  };

  // and we load the project
  useEffect(() => {
    loadGraphFct();
  }, [dispatch, shouldRerender]);

  // we do NOT hold the state in the page: it's completely pushed into redux and the (following) containers do the wiring
  return (
    <div
      className="graph-upper-div ml-[10%]"
      id="graph-wrapper"
      style={{
        height: currentUploadsStateList.length > 0 ? `calc(100% - ${UPLOAD_BAR_HEIGHT})` : "100%",
      }}
    >
      <SVGGraphContainer loading={isLoading} />
    </div>
  );
};
export default EditProjectScenes;
